import { render, staticRenderFns } from "./TrailerRender.vue?vue&type=template&id=15d1eb0d&scoped=true"
import script from "./TrailerRender.vue?vue&type=script&lang=js"
export * from "./TrailerRender.vue?vue&type=script&lang=js"
import style0 from "./TrailerRender.vue?vue&type=style&index=0&id=15d1eb0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d1eb0d",
  null
  
)

export default component.exports